import { Routes } from '@angular/router';
import { modalGuard } from '@core/guards/modal.guard';
import { canDeactivateCanvasFn } from '@core/guards/canvas.guard';
import { CanvasDropRegistry } from './utilities/canvas-drop-registry';
import { CanvasState } from './utilities/canvas-state';
import { CanvasClipboardService } from './utilities/canvas-clipboard.service';
import { CanvasContextMenuController } from './utilities/canvas-context-menu.controller';
import { CanvasKeyboardShortcutsService } from './utilities/canvas-keyboard-shortcuts.service';
import { CanvasPasteService } from './utilities/canvas-paste.service';
import { RealDataPreviewService } from './services/real-data-preview.service';

export const routes: Routes = [
	{
		path: '',
		loadComponent: () =>
			import('./page-designer.component').then(
				(component) => component.PageDesignerComponent
			),
		providers: [
			CanvasState,
			CanvasDropRegistry,
			CanvasClipboardService,
			CanvasContextMenuController,
			CanvasKeyboardShortcutsService,
			CanvasPasteService,
			RealDataPreviewService
		],
		canDeactivate: [canDeactivateCanvasFn, modalGuard]
	}
];
